export { LawFirm as default } from '@/screens/home/LawFirm'
